import { useEffect, useState } from 'react';
import { viewerApi, ViewerLinks } from '@/services/viewerApi';

// One fetch per page load, shared by every sidebar instance. The backend
// already caches the viewer's answer; a failure here just means no link.
const EMPTY: ViewerLinks = { enabled: false, farms: {} };
let cached: ViewerLinks | null = null;
let inflight: Promise<ViewerLinks> | null = null;

function fetchLinks(): Promise<ViewerLinks> {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = viewerApi.links()
      .then((r) => (cached = r && typeof r.farms === 'object' ? r : EMPTY))
      .catch(() => (cached = EMPTY))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** Deep link to this farm in the LiDAR viewer, or null when there is none. */
export function useViewerLink(farmId: string | undefined): string | null {
  const [links, setLinks] = useState<ViewerLinks | null>(cached);
  useEffect(() => {
    if (cached) return;
    let alive = true;
    fetchLinks().then((r) => { if (alive) setLinks(r); });
    return () => { alive = false; };
  }, []);
  if (!farmId || !links) return null;
  return links.farms[farmId] ?? null;
}

/** Tests only: forget the cached answer. */
export function resetViewerLinksCache(): void {
  cached = null;
  inflight = null;
}
